import i18next from 'i18next';
import { CONFERENCE_JOINED } from '../../../react/features/base/conference/actionTypes';
import { participantUpdated } from '../../../react/features/base/participants/actions';
import { PARTICIPANT_ROLE } from '../../../react/features/base/participants/constants';
import { getLocalParticipant, isLocalParticipantModerator } from '../../../react/features/base/participants/functions';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { iAmVisitor } from '../../../react/features/visitors/functions';
import { SET_CONFERENCE_LANG } from './actionTypes';
/**
 * Implements the entry point of the middleware of the xbees/base/conference.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register((store) => next => action => {
    const result = next(action);
    switch (action.type) {
        case CONFERENCE_JOINED: {
            const { dispatch, getState } = store;
            const state = getState();
            const { isExternalMeeting, isInternalUser, isXbees } = state['features/base/config'];
            if (!isXbees) {
                break;
            }
            if (isExternalMeeting && !isInternalUser
                && isLocalParticipantModerator(state) && !iAmVisitor(state)) {
                const localId = getLocalParticipant(state)?.id ?? '';
                dispatch(participantUpdated({
                    id: localId,
                    role: PARTICIPANT_ROLE.PARTICIPANT
                }));
            }
            break;
        }
        case SET_CONFERENCE_LANG: {
            const { getState } = store;
            // @ts-ignore
            const { systemLanguage } = getState()['xbees/base/conference'];
            if (systemLanguage && i18next) {
                i18next.changeLanguage(systemLanguage);
            }
            break;
        }
    }
    return result;
});
